import React from "react";
import { useRecordContext } from "react-admin";
import ContextSection from "./ContextSection";
import RawDataUploadSection from "./RawDataUploadSection";
import TraceabilitySection from "./TraceabilitySection";
import LastTraceabilityUploadSection from "./LastTraceabilityUploadSection";
import EcomReferencesSection from "./EcomReferencesSection";
import QRCodesSection from "./QRCodesSection";
import SupplyMapSection from "./SupplyMapSection";
import CalculationSection from "./CalculationSection";
import BackupRecoverySection from "./BackupRecoverySection";

const CalculationTab = ({
  fileRef,
  loadingStates,
  uploadOptions,
  setUploadOptions,
  upload,
  uploadRawData,
  validateExcel,
  refineTraceability,
  updateVersion,
  downloadTraceability,
  errors,
  traceabilityWarnings,
  lastUploadReloadKey,
  remove,
  downloadBackupSupplyMap,
  downloadBackupRecovery,
  recoverBackup,
  runCalculation,
  runCircularity,
  calculationStatus,
  circularityStatus,
  lcaDownloadStatus,
  circularityDownloadStatus,
  downloadCircularity,
  isCircularityCalculateable,
  selectedFile,
  setSelectedFile,
  hasBackup,
  backups,
  isCalculateable,
  bcomeVersionMap,
  bcomeVersionRecordMap,
  selectedBcomeVersionId,
  setSelectedBcomeVersionId,
  pendingBcomeVersionId
}) => {
  const record = useRecordContext();

  if (!record) return null;

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <ContextSection record={record} pendingBcomeVersionId={pendingBcomeVersionId} />

      <RawDataUploadSection
        fileRef={fileRef}
        selectedFile={selectedFile}
        handleFileChange={handleFileChange}
        uploadOptions={uploadOptions}
        setUploadOptions={setUploadOptions}
        uploadRawData={uploadRawData}
        loading={loadingStates.upload}
        bcomeVersionMap={bcomeVersionMap}
        selectedBcomeVersionId={selectedBcomeVersionId}
        setSelectedBcomeVersionId={setSelectedBcomeVersionId}
      />

      <TraceabilitySection
        validateExcel={validateExcel}
        refineTraceability={refineTraceability}
        updateVersion={updateVersion}
        downloadTraceability={downloadTraceability}
        currentVersion={record.version}
        bcomeVersionRecordMap={bcomeVersionRecordMap}
        errors={errors}
        warnings={traceabilityWarnings}
        uploadedName={selectedFile?.name}
        loading={loadingStates.validateTraceability}
        loadingRefine={loadingStates.refineTraceability}
        loadingUpdateVersion={loadingStates.updateVersion}
        loadingDownload={loadingStates.downloadTraceability}
      />

      <LastTraceabilityUploadSection record={record} reloadKey={lastUploadReloadKey} />

      <EcomReferencesSection
        validateExcel={validateExcel}
        remove={remove}
        loadingValidate={loadingStates.validateEcom}
        loadingDelete={loadingStates.deleteEcom}
      />

      <QRCodesSection
        upload={upload}
        loading={loadingStates.uploadArticleImages}
      />

      <SupplyMapSection
        record={record}
        downloadBackup={downloadBackupSupplyMap}
        runCalculation={runCalculation}
        loadingDownload={loadingStates.downloadBackupSupplyMap}
        loadingCalculation={loadingStates.runCalculation}
        calculationStatus={calculationStatus}
        downloadStatus={lcaDownloadStatus}
        otherCalculationBusy={loadingStates.runCircularity || loadingStates.downloadCircularity}
        isCalculateable={isCalculateable}
        pendingBcomeVersionId={pendingBcomeVersionId}
      />

      <CalculationSection
        record={record}
        runCircularity={runCircularity}
        downloadCircularity={downloadCircularity}
        loadingCalculation={loadingStates.runCircularity}
        calculationStatus={circularityStatus}
        downloadStatus={circularityDownloadStatus}
        otherCalculationBusy={loadingStates.runCalculation || loadingStates.downloadBackupSupplyMap}
        loadingDownload={loadingStates.downloadCircularity}
        isCalculateable={isCircularityCalculateable}
      />

      <BackupRecoverySection
        record={record}
        downloadBackup={downloadBackupRecovery}
        recoverBackup={recoverBackup}
        loadingDownload={loadingStates.downloadBackupRecovery}
        loadingRecover={loadingStates.recoverBackup}
        hasBackup={hasBackup}
        backups={backups}
      />
    </div>
  );
};

export default CalculationTab;
